import script from "./SalesAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./SalesAnalysis.vue?vue&type=style&index=0&id=36e7ca4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36e7ca4a"]])

export default __exports__